import { useMatomo } from '@datapunt/matomo-tracker-react';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { connect } from 'react-redux';
import HomePageLayout from '../../components/HomePageLayout';
import Metadata from '../../components/Metadata';
import {
    fetchArticleHomepage,
    fetchCalendar,
    fetchOffers,
} from '../../store/actions';
import fetchSquirrelNews from '../../store/actions/getSquirrelNewsAction';
import { RG_DESCRIPTION } from '../../utils/constants';

/**
 * HomePage Component
 * - Displays the homepage with articles, offers, and a calendar.
 * - Integrates analytics tracking with Matomo.
 * - Dynamically fetches content for articles, offers, calendar events, and squirrel news.
 * - Includes a gallery-style layout for content display.
 */
const HomePage = ({
    fetchArticleHomepage,
    fetchOffers,
    mainArticle,
    publisherArticles = [],
    newsArticles,
    latestOffers,
    wissenArticles,
    gtTippsArticles,
    projekteArticles,
    fetchCalendar,
    calendarContent,
    fetchSquirrelNews,
    squirrelNewsArticles,
}) => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');

        fetchArticleHomepage({ locale: i18n.language });
        fetchSquirrelNews();
        fetchOffers({ start: 0, limit: 4, locale: i18n.language });
        fetchCalendar(startOfMonth);
    }, [
        fetchArticleHomepage,
        fetchCalendar,
        fetchOffers,
        fetchSquirrelNews,
        i18n.language,
    ]);
    const { trackPageView } = useMatomo();
    // Track page view
    useEffect(() => {
        const pageTitle = `Regio Health News - Home Page`;
        const pageUrl = process.env.REACT_APP_BASE_PAGE_URL.replace(/\/+$/, ''); // Ensure no trailing slash

        trackPageView({
            documentTitle: pageTitle,
            href: pageUrl,
        });
    }, []);

    return (
        <>
            <Metadata
                title="Regionale Gesundheit"
                description={RG_DESCRIPTION}
                url={`${process.env.REACT_APP_BASE_PAGE_URL}`}
            />
            <HomePageLayout
                mainArticle={mainArticle}
                newsArticles={newsArticles}
                publisherArticles={publisherArticles}
                latestOffers={latestOffers}
                buttonText={t('homePage.moreContent')}
                wissenArticles={wissenArticles}
                gtTippsArticles={gtTippsArticles}
                projekteArticles={projekteArticles}
                calendarContent={calendarContent}
                squirrelNewsArticles={squirrelNewsArticles}
            />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        mainArticle: state.articles.articlesHomepage.mainArticle,
        publisherArticles: state.articles.articlesHomepage.publisherArticles,
        newsArticles: state.articles.articlesHomepage.newsArticles,
        latestOffers: state.offers.offers,
        wissenArticles: state.articles.articlesHomepage.wissenArticles,
        gtTippsArticles: state.articles.articlesHomepage.gtTippsArticles,
        projekteArticles: state.articles.articlesHomepage.projekteArticles,
        calendarContent: state.calendar.content,
        squirrelNewsArticles: state.squirrelNewsArticles,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchArticleHomepage: ({ locale }) =>
            dispatch(fetchArticleHomepage({ locale })),
        fetchOffers: ({ start, limit, locale }) =>
            dispatch(fetchOffers({ start, limit, locale })),
        fetchCalendar: (startOfMonth, endOfMonth) =>
            dispatch(fetchCalendar(startOfMonth, endOfMonth)),
        fetchSquirrelNews: () => dispatch(fetchSquirrelNews()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
